import api from '@/lib/api';

export type PaymentProvider = 'paypal' | 'stripe' | 'klarna' | 'shopify';

export interface ProviderConfig {
  provider: PaymentProvider;
  label: string;
  fields: string[];
  connected: boolean;
  viaShopIntegration?: boolean; // Shopify: mevcut Shop-Integration'ı kullanır (form yok)
  config: Record<string, string>; // secrets = '[HIDDEN]'
  is_active: boolean;
  last_test_at?: string | null;
  last_test_status?: string | null;
  last_test_error?: string | null;
}

export interface ScheduledRefund {
  id: string;
  execute_at: string;
  status: string;
  requested_by_name?: string;
}

export interface PaymentStatus {
  found: boolean;
  status?: 'paid' | 'pending' | 'refunded' | 'partially_refunded' | 'failed' | 'unknown';
  raw?: string;
  amount?: { value: string; currency_code: string };
  createTime?: string;
  error?: string;
  scheduledRefund?: ScheduledRefund | null;
}

class PaymentsService {
  async getProviders(): Promise<ProviderConfig[]> {
    const { data } = await api.get('/payments/providers');
    return data?.data || [];
  }
  async saveConfig(provider: PaymentProvider, config: Record<string, string>): Promise<ProviderConfig> {
    const { data } = await api.put(`/payments/${provider}/config`, config);
    return data?.data;
  }
  async test(provider: PaymentProvider): Promise<{ success: boolean; message?: string }> {
    const { data } = await api.post(`/payments/${provider}/test`, {});
    return { success: !!data?.success, message: data?.message };
  }
  async getStatus(provider: PaymentProvider, txId: string, organizationId?: string): Promise<PaymentStatus> {
    const { data } = await api.get(`/payments/${provider}/status/${encodeURIComponent(txId)}`, { params: organizationId ? { organizationId } : {} });
    return data?.data;
  }
  async refund(provider: PaymentProvider, txId: string, opts?: { amount?: { value: string; currency_code?: string }; orderNumber?: string; ticketId?: string; organizationId?: string }): Promise<{ success: boolean; message?: string; data?: any }> {
    const { data } = await api.post(`/payments/${provider}/refund`, { txId, amount: opts?.amount, orderNumber: opts?.orderNumber, ticketId: opts?.ticketId, organizationId: opts?.organizationId });
    return { success: !!data?.success, message: data?.message, data: data?.data };
  }
  async cancelRefund(refundId: string): Promise<{ success: boolean; message?: string }> {
    const { data } = await api.post(`/payments/refunds/${refundId}/cancel`, {});
    return { success: !!data?.success, message: data?.message };
  }
}

// paymentMethod string → provider
export function detectProvider(paymentMethod?: string): PaymentProvider | null {
  const s = (paymentMethod || '').toLowerCase();
  if (/paypal/.test(s)) return 'paypal';
  if (/klarna/.test(s)) return 'klarna';
  if (/shopify/.test(s)) return 'shopify';                 // Shopify Payments → Shopify Admin API (Stripe değil)
  if (/stripe|credit.?card|kreditkarte|card/.test(s)) return 'stripe';
  return null;
}

export default new PaymentsService();
